/**
 * @flow
 * @relayHash 99443e13dd6003dceb0158e6bf4c934b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Epg_viewer$ref = any;
export type Epg_Refetch_QueryVariables = {|
  day?: ?string
|};
export type Epg_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Epg_viewer$ref
  |}
|};
export type Epg_Refetch_Query = {|
  variables: Epg_Refetch_QueryVariables,
  response: Epg_Refetch_QueryResponse,
|};
*/


/*
query Epg_Refetch_Query(
  $day: String
) {
  viewer {
    ...Epg_viewer_1Nqzrl
    id
  }
}

fragment Epg_viewer_1Nqzrl on Viewer {
  episodes(first: -1, day: $day, showAll: true) {
    edges {
      node {
        id
        startDate
        endDate
        title
        state
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "day",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "Epg_Refetch_Query",
  "id": null,
  "text": "query Epg_Refetch_Query(\n  $day: String\n) {\n  viewer {\n    ...Epg_viewer_1Nqzrl\n    id\n  }\n}\n\nfragment Epg_viewer_1Nqzrl on Viewer {\n  episodes(first: -1, day: $day, showAll: true) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        title\n        state\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Epg_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Epg_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "day",
                "variableName": "day",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Epg_Refetch_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "episodes",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "day",
                "variableName": "day",
                "type": "String"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": -1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "showAll",
                "value": true,
                "type": "Boolean"
              }
            ],
            "concreteType": "TVShowEpisodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TVShowEpisodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TVShowEpisode",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "startDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "state",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8a1899a9f3f360da1b8a732de48e40dc';
module.exports = node;



// WEBPACK FOOTER //
// src/components/epg/__generated__/Epg_Refetch_Query.graphql.js